import Vue from 'vue';
import Dialog from '../components/Widgets/Dialog.vue';

const api = {

    alert: (message) => {
        alert(message);
    },
    alertAsync: async (message) => {
        await implementation.asyncSetup.dialog(Dialog, message, 'alert');
    },
    confirm: (message) => {
        return confirm(message);
    },
    confirmAsync: async (message, primaryCaption = 'Ok', secondaryCaption = 'Cancel', focus = 'primary') => {
        return (await implementation.asyncSetup.dialog(Dialog, message, 'confirm', primaryCaption, secondaryCaption, focus));
    },
    confirmCancelAsync: async (message) => {
        return (await implementation.asyncSetup.dialog(Dialog, message, 'confirm', 'Yes', 'No', 'secondary'));
    },
    showDialogAsync: async (component, model) => {
        return (await implementation.asyncSetup.dialog(component, '', '', '', '', '', model));
    },
}

const implementation = {

    asyncSetup: {
        dialog: async (component, message, type, primaryCaption, secondaryCaption, focus, customModel) => implementation.asyncSetup.createDialog(component, message, type, primaryCaption, secondaryCaption, focus, customModel),
        createDialog: (component, message, type, primaryCaption, secondaryCaption, focus, customModel) => {

            // https://css-tricks.com/creating-vue-js-component-instances-programmatically/

            return new Promise((complete) => {

                var dialogOptions = {
                    message: message,
                    dialogType: type,
                    button1Caption: primaryCaption || 'Ok',
                    button2Caption: secondaryCaption || 'Cancel',
                    focus: focus,
                    customModel: customModel || {},
                    button1Callback: () => {
                        document.body.querySelector('div.root-dialog-container').style.display = "none";
                        complete(true);
                    },
                    button2Callback: () => {
                        document.body.querySelector('div.root-dialog-container').style.display = "none";
                        complete(false);
                    },
                    defaultButton: 1
                }

                var ComponentClass = Vue.extend(component);
                var dialog = new ComponentClass({propsData: { options: dialogOptions }});

                dialog.$mount();

                var root = document.getElementById('dialog-root');
                root.innerHTML = "";
                root.appendChild(dialog.$el);
                root.querySelector('div.modal').style.display = "block";
            });
        }
    }

}


export default api;